import React, { useEffect } from 'react';
// FIX: The ProductGroup type is now exported from the central types.ts file.
import { ProductGroup } from '../types';

interface ProductSuggestionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    suggestions: ProductGroup[];
}

export const ProductSuggestionModal: React.FC<ProductSuggestionModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    suggestions,
}) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                onConfirm();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose, onConfirm]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="product-suggestion-modal-title"
        >
            <div
                className="bg-white rounded-lg shadow-xl p-6 m-4 max-w-3xl w-full max-h-[90vh] flex flex-col"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center pb-3 border-b">
                    <h2 id="product-suggestion-modal-title" className="text-xl font-bold text-gray-800">Návrh na sloučení produktů</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="my-4 overflow-y-auto">
                    <p className="text-sm text-gray-600 mb-4">
                        AI navrhuje sloučit následující položky. Pokud potvrdíte, názvy produktů budou <strong>trvale přepsány</strong> ve všech vašich účtenkách pro zajištění konzistence.
                    </p>
                    <div className="space-y-4">
                        {suggestions.map((group, index) => (
                            <div key={index} className="border rounded-md p-4">
                                <p className="text-sm text-gray-500">Bude sjednoceno pod název:</p>
                                <h4 className="font-semibold text-blue-700 mb-2">{group.canonicalName}</h4>
                                <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 pl-2">
                                    {group.originalNames.map(name => <li key={name}>{name}</li>)}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-auto pt-4 border-t flex justify-end gap-3">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                        Zrušit
                    </button>
                    <button onClick={onConfirm} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                        Potvrdit a sloučit
                    </button>
                </div>
            </div>
        </div>
    );
};
